module.exports = __webpack_public_path__ + "img/doors2.15b0d7b5.svg";